import {
    putZoneLoading,
    putZoneRequest,
    putZoneSuccess,
    putZoneReject,
    putZoneReset
} from "../../actions/zone/put";

export const putZone = (formData) => async (dispatch, getState) => {
    dispatch(putZoneLoading());
    try {
        const { data } = await putZoneRequest(formData, getState);
        dispatch(putZoneSuccess(data))
    } catch (error) {
        dispatch(putZoneReject(error))
    } finally {
        setTimeout(() => { dispatch(putZoneReset()) }, 3000);
    }
    return Promise.resolve();
};